import { generateInvoiceBookingService } from '../../../services/customer/ticketBookingServices';

export default async function generateInvoiceBooking(id, guid) {
  const res = await generateInvoiceBookingService(id, guid);
  if (res.status === 'success') {
    window.location.replace('/ka/profile?tab=booked-statements');
  }
}
